import type { Community } from '@communities/community/domain/Community';
import { CommunityAuditHeaderSection } from '@internal-audit/components/CommunityAuditHeaderSection';
import type { FlexibleAuditSession } from '@internal-audit/domain/graphql-types';

interface SessionsPageHeaderProps {
  community: Community | null;
  sessions: FlexibleAuditSession[];
  sessionsLoading: boolean;
}

/**
 * Header section component with hero background
 * Contains only the community audit header - page header moved to content section
 */
export function SessionsPageHeader({ community, sessions, sessionsLoading }: SessionsPageHeaderProps) {
  return (
    <div>
      <CommunityAuditHeaderSection auditSessions={sessions} community={community} isLoading={sessionsLoading} />
    </div>
  );
}
